import fetch from 'isomorphic-fetch'
import * as general from '../constants/General'
import * as resource from '../constants/Resources'
import * as types from '../constants/Types'
import * as dataActions from './dataActions'
import * as generalActions from './generalActions'
import * as layoutActions from './layoutActions'
import * as modalActions from '../modal/actions/modalActions'
import * as receiptActions from './receiptActions'
import * as systemSetting from '../constants/SystemSettings'

export function checkVatNumberAfterEntry(customer) {
  return (dispatch, getState) => {
    const enableInfoRequiredForInvoice = getState().generalState.systemSettings[systemSetting.ENABLE_INFO_REQUIRED_FOR_INVOICE];
    if ((customer.IdentificationNumber === null || customer.IdentificationNumber === undefined) && customer.VatNumber === '' && enableInfoRequiredForInvoice === 'true') {
      dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.INVALID_VAT_MESSAGE))));
    }
    else {
      dispatch(receiptActions.setShouldInvoice(!getState().receiptState.receipt.shouldinvoice));
    }
  }
}

export function sendInvoice(customerId) {
  return dispatch => {
    const items = [
      { ItemId: types.INVOICE_NONE, Description: dispatch(dataActions.getTranslation(resource.INVOICE_LATER)) },
      { ItemId: types.INVOICE_EMAIL_PRINT, Description: dispatch(dataActions.getTranslation(resource.EMAIL_AND_PRINT)) },
      { ItemId: types.INVOICE_EMAIL, Description: dispatch(dataActions.getTranslation(resource.SEND_MAIL)) },
      { ItemId: types.INVOICE_PRINT, Description: dispatch(dataActions.getTranslation(resource.PRINT)) }
    ];

    dispatch(generalActions.setSelectModal(items, true, dispatch(dataActions.getTranslation(resource.PRINT_INVOICE_QUESTION)), checkCustomerToInvoice, [customerId]));
  }
}

export function checkCustomerToInvoice(actionType, invoiceTypeDescription, customerId) {
  return (dispatch, getState) => {
    if (!(customerId > -1)) {
      dispatch(generalActions.setMessageModal(dispatch(dataActions.getTranslation(resource.NO_CUSTOMER_LINKED_TO_RECEIPT_MESSAGE))));
      return;
    }

    let apiUrl = `${general.API_URL_GETCUSTOMER}${customerId}`;
    fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'invoiceActions:checkCustomerToInvoice'
      }
    })
      .then(response => response.json())
      .then(customer => {
        let emailAddress = customer.Email === null ? customer.Email2 : customer.Email;

        if ((actionType === types.INVOICE_EMAIL_PRINT || actionType === types.INVOICE_EMAIL) &&
          (emailAddress === undefined || emailAddress === null || emailAddress === "")) {
          dispatch(askMailQuestion(customer, actionType));
        }
        else {
          //Bonnen ophalen die nog gefactureerd moeten worden
          if (actionType !== types.INVOICE_NONE && customer !== null && customer.CustomerId > 0) {
            dispatch(getReceiptsToInvoice(customer.CustomerId, actionType));
          }
        }
      });
  }
}

function askMailQuestion(customer, actionType) {
  return dispatch => {
    const items = [
      { ItemId: 0, Description: dispatch(dataActions.getTranslation(resource.LABEL_NO)) },
      { ItemId: 1, Description: dispatch(dataActions.getTranslation(resource.LABEL_YES)) }
    ];

    dispatch(generalActions.setSelectModal(items, true, dispatch(dataActions.getTranslation(resource.SET_MAIL_QUESTION)), setMailAddress, [customer, actionType], false));
  }
}

function setMailAddress(askMailOption, askMailOptionDescription, customer, actionType) {
  return dispatch => {
    if (customer === undefined || customer === null) {
      dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.CUSTOMER_NOT_FOUND))));
      return;
    }

    if (askMailOption === 1) {
      dispatch(layoutActions.toggleKeyboard(true, '#hfEmail', dispatch(dataActions.getTranslation(resource.EMAIL)), saveCustomerEmailaddress, [customer], true));

      if (actionType !== types.INVOICE_NONE) {
        dispatch(getReceiptsToInvoice(customer.CustomerId, actionType));
      }
    }
    else {
      dispatch(sendInvoice(customer.CustomerId));
    }
  }
}

function getReceiptsToInvoice(customerId, invoiceType) {
  return (dispatch, getState) => {

    let apiUrl = `${general.API_URL_GET_RECEIPTS_TO_INVOICE}${customerId}`;
    fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'invoiceActions:getReceiptsToInvoice'
      }
    })
      .then(response => response.json())
      .then(json => {
        //Factureren van bonnen
        dispatch(modalActions.setInvoiceModal(true, invoiceType, json));
      });
  }
}

export function createInvoice(actionType, receipts, reference) {
  return (dispatch, getState) => {
    var invoiceDate = new Date().toISOString();
    var trimmedReference = typeof reference === 'string' ? reference.trim() : '';
    var apiUrl = general.API_URL_CREATE_INVOICE + invoiceDate;
    if (trimmedReference !== '') {
      apiUrl += '/' + encodeURIComponent(trimmedReference);
    }
    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'invoiceActions:createInvoice'
      },
      body: JSON.stringify(receipts)
    })
      .then(response => response.json())
      .then(result => {
        if (result === null) {
          dispatch(generalActions.setMessageModal(true, 'Factuur niet aangemaakt!'));
          return;
        }

        //Mailen/printen van factuur
        dispatch(invoiceAction(actionType, result.InvoiceId));

        if (actionType === types.INVOICE_NONE) {
          dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.NO_INVOICE_MESSAGE))));
        }
      });
  }
}

export function invoiceAction(type, invoiceid) {
  return (dispatch, getState) => {
    fetch(`${general.API_URL_INVOICE_ACTION}${type}/${invoiceid}/${getState().generalState.posId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'invoiceActions:invoiceAction'
      }
    })
      .then(response => response.json())
      .then(result => {
        if (!result || !result.success) {
          dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.INVOICE_ACTION_ERROR))));
        }
      })
  }
}

export function saveCustomerEmailaddress(emailAddress, customer, callbackFunc) {
  return dispatch => {
    if (customer !== null) {
      customer.Email = emailAddress;
      dispatch(saveCustomer(customer, callbackFunc, null));
    }
  }
}

export function saveCustomerVatNumber(vatNumber, customer, callbackFunc) {
  return (dispatch, getState) => {
    if (vatNumber === '') {
      customer.vatNumber = vatNumber;
      dispatch(saveCustomer(customer, callbackFunc, null));
    } else {
      if (customer !== null) {
        const disableVatNumberValidation = getState().generalState.systemSettings[systemSetting.DISABLE_VATNUMBER_VALIDATION];
        if (disableVatNumberValidation) {
          customer.vatNumber = vatNumber;
          dispatch(saveCustomer(customer, callbackFunc, null));
        } else {
          let apiUrl = `${general.API_URL_VALIDATE_VATNUMBER}/${vatNumber}`;
          fetch(apiUrl, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Context': 'CreateCustomerModal:validateVatnumber'
            }
          }).then(response => response.json())
            .then(response => {
              let vatnumberValidation = response;
              if (vatnumberValidation === false) {
                dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.ERROR_INCORRECT_VATNUMBER))));
              }
              else {
                customer.vatNumber = vatNumber;
                dispatch(saveCustomer(customer, callbackFunc, null));
              }
            });
        }
      }
    }
  }
}

export function saveCustomer(customer, callbackFunc, extraCallbackFunc) {
  return (dispatch, getState) => {
    let body = JSON.stringify(customer);
    fetch(general.API_URL_SAVE_CUSTOMER, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'invoiceActions:saveCustomer'
      },
      body: body
    })
      .then(response => response.json())
      .then((savedCustomer) => {
        let cust = (savedCustomer === undefined || savedCustomer === null) ? customer : savedCustomer;
        if (callbackFunc) {
          dispatch(callbackFunc(cust));
        }
        if (extraCallbackFunc) {
          extraCallbackFunc(cust);
        }
      });
  }
}

export function saveTicket(ticket, callbackFunc, extraCallbackFunc) {
  return (dispatch, getState) => {
    let body = JSON.stringify(ticket);
    fetch(general.API_URL_SAVE_TICKET, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'invoiceActions:saveTicket'
      },
      body: body
    })
      .then(response => response.json())
      .then((savedTicket) => {
        let tick = (savedTicket === undefined || savedTicket === null) ? ticket : savedTicket;
        if (callbackFunc) {
          dispatch(callbackFunc(tick));
        }
        if (extraCallbackFunc) {
          extraCallbackFunc(tick);
        }
      });
  }
}

export function deleteTicket(ticket, callbackFunc, extraCallbackFunc) {
  return (dispatch, getState) => {
    let body = JSON.stringify(ticket);
    fetch(general.API_URL_DELETE_TICKET, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'invoiceActions:deleteTicket'
      },
      body: body
    })
      .then(response => response.json())
      .then((deletedTicket) => {
        let tick = (deletedTicket === undefined || deletedTicket === null) ? ticket : deletedTicket;
        if (callbackFunc) {
          dispatch(callbackFunc(tick));
        }
        if (extraCallbackFunc) {
          extraCallbackFunc(tick);
        }
      });
  }
}

export function getOriginalInvoice(customerid, originalInvoiceNumber, callbackFunc, errorCallbackFunc) {
  return (dispatch, getState) => {
    dispatch(generalActions.loadingStart());
    let apiUrl = `${general.API_URL_GET_ORIGINALINVOICE}/${customerid}/${originalInvoiceNumber}`;
    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'invoiceActions:getOriginalInvoice'
      },
    })
      .then(response => response.json())
      .then((invoice) => {
        if (callbackFunc) {
          callbackFunc(invoice);
        }
        dispatch(generalActions.loadingEnd());
      })
      .catch((e) => {
        if (errorCallbackFunc) {
          errorCallbackFunc(e);
        } else if (callbackFunc) {
          callbackFunc(null);
        }
        dispatch(generalActions.loadingEnd());
      });
  }
}

function setInvoiceReferenceCallback(invoiceReference) {
  return (dispatch, getState) => {
    if (invoiceReference) {
      const trimmedInvoiceReference = invoiceReference.trim();
      if (trimmedInvoiceReference !== '') {
        dispatch(receiptActions.setInvoiceReference(trimmedInvoiceReference));
      }
    }
  }
}

export function setInvoiceReference() {
  return (dispatch, getState) => {
    if (getState().receiptState.receipt.shouldinvoice) {
      dispatch(modalActions.setInputModal(true,
        dispatch(dataActions.getTranslation(resource.INVOICE_REFERENCE_INPUT_MESSAGE)),
        dispatch(dataActions.getTranslation(resource.INVOICE_REFERENCE)),
        setInvoiceReferenceCallback,
        [],
        dispatch));
    } else {
      dispatch(toggleInvoicingOnOff())
        .then(() => {
          dispatch(modalActions.setInputModal(true,
            dispatch(dataActions.getTranslation(resource.INVOICE_REFERENCE_INPUT_MESSAGE)),
            dispatch(dataActions.getTranslation(resource.INVOICE_REFERENCE)),
            setInvoiceReferenceCallback,
            [],
            dispatch));
        });
    }
  }
}

export function toggleInvoicingOnOff() {
  return (dispatch, getState) => new Promise(function (resolve, reject) {
    var customer = getState().receiptState.receipt.customer;

    if (customer === null || !(customer.customerid > 0)) {
      dispatch(receiptActions.showCustomerBase(null))
        .then(() => {
          const enableCustomerInfoRequiredForInvoice = getState().generalState.systemSettings[systemSetting.ENABLE_CUSTOMER_INFO_REQUIRED_FOR_INVOICE];
          customer = getState().receiptState.receipt.customer;
          if (customer !== null && customer.customerid > 0) {
            if (enableCustomerInfoRequiredForInvoice === 'true') {
              dispatch(checkCustomer(customer));
            } else {
              dispatch(checkCustomerVATNumber(customer))
                .then(() => {
                  resolve();
                });
            }
          }
        });
    }
    else {
      var shouldInvoice = getState().receiptState.receipt.shouldinvoice;
      var invoiceOnly = customer.invoiceOnly;
      if (shouldInvoice && invoiceOnly) {
        dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.SHOULD_INVOICE))));
      } else {
        const enableInfoRequiredForInvoice = getState().generalState.systemSettings[systemSetting.ENABLE_CUSTOMER_INFO_REQUIRED_FOR_INVOICE];
        if (enableInfoRequiredForInvoice === 'true') {
          dispatch(checkCustomer(customer));
        } else {
          dispatch(checkCustomerVATNumber(customer))
            .then(() => {
              resolve();
            });
        }
      }
    }
  })
}

function checkCustomer(customer) {
  return (dispatch, getState) => {
    return fetch(`${general.API_URL_GETCUSTOMER}${customer.customerid}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'PosId': getState().generalState.posId,
        'Context': 'receiptActions:processSetInvoice'
      }
    })
      .then(response => response.json())
      .then(json => {
        if (json) {
          if (json.ZipCode === null || json.ZipCode === ""
            || json.City === null || json.City === ""
            || json.Street === null || json.Street === "") {
            dispatch(receiptActions.showCustomer());
          } else {
            dispatch(checkCustomerVATNumber(customer));
          }
        }
        else {
          dispatch(generalActions.setMessageModal(true, dispatch(dataActions.getTranslation(resource.CUSTOMER_NOT_FOUND))));
        }
      });
  }
}

function checkCustomerVATNumber(customer) {
  return (dispatch, getState) => {
    try {
      return fetch(`${general.API_URL_GETCUSTOMER}${customer.customerid}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'PosId': getState().generalState.posId,
          'Context': 'receiptActions:processSetInvoice'
        }
      })
      .then(response => response.json())
      .then(json => {
        if (json) {
          let invoiceCustomer = json;
          if (json.InvoiceCustomerID !== null && json.InvoiceCustomer !== 0) {
            invoiceCustomer = json.InvoiceCustomer;
          }
          const enableCustomerInfoRequiredForInvoice = getState().generalState.systemSettings[systemSetting.ENABLE_CUSTOMER_INFO_REQUIRED_FOR_INVOICE];

          const vatMissing = invoiceCustomer.VatNumber === null || invoiceCustomer.VatNumber === "";
          const idMissing = invoiceCustomer.IdentificationNumber === null || invoiceCustomer.IdentificationNumber === "";

          if (vatMissing) {
            if (enableCustomerInfoRequiredForInvoice && idMissing) {
              dispatch(
                layoutActions.toggleKeyboard(
                  true,
                  '#hfTouchKeyboard',
                  dispatch(dataActions.getTranslation(resource.VAT_NUMBER)),
                  saveCustomerVatNumber,
                  [invoiceCustomer, checkVatNumberAfterEntry],
                  true
                )
              );
            } else if (enableCustomerInfoRequiredForInvoice && !idMissing) {
              dispatch(receiptActions.setShouldInvoice(!getState().receiptState.receipt.shouldinvoice));
            } else {
              dispatch(
                layoutActions.toggleKeyboard(
                  true,
                  '#hfTouchKeyboard',
                  dispatch(dataActions.getTranslation(resource.VAT_NUMBER)),
                  saveCustomerVatNumber,
                  [invoiceCustomer, checkVatNumberAfterEntry],
                  true
                )
              );
            }
          } else {
            dispatch(receiptActions.setShouldInvoice(!getState().receiptState.receipt.shouldinvoice));
          }
        } else {
          dispatch(
            generalActions.setMessageModal(
              true,
              dispatch(dataActions.getTranslation(resource.CUSTOMER_NOT_FOUND))
            )
          );
        }
      });
    } catch (error) {
      dispatch(
        generalActions.setMessageModal(
          true,
          dispatch(dataActions.getTranslation(resource.CUSTOMER_NOT_FOUND))
        )
      );
    }
  };
}
export function printInvoice() {
  return (dispatch, getState) => {
    var customer = getState().receiptState.receipt.customer;

    if (customer === null || !(customer.customerid > 0)) {
      dispatch(receiptActions.showCustomerBase(null))
        .then(() => {
          customer = getState().receiptState.receipt.customer;
          if (customer !== null && customer.customerid > 0) {
            dispatch(sendInvoice(customer.customerid));
          }
        });
    }
    else {
      dispatch(sendInvoice(customer.customerid));
    }
  }
}



// WEBPACK FOOTER //
// src/actions/invoiceActions.js